import { render, staticRenderFns } from "./jdapply.vue?vue&type=template&id=9af81008&scoped=true"
import script from "./jdapply.vue?vue&type=script&lang=js"
export * from "./jdapply.vue?vue&type=script&lang=js"
import style0 from "./jdapply.vue?vue&type=style&index=0&id=9af81008&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af81008",
  null
  
)

export default component.exports